module.exports = __webpack_public_path__ + "img/zk2.d509a737.jpg";